import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import { backendURL } from '../../data/config.json'

//Components
import Breadcrumb from '../../menus/FleetBreadcrum'
import Fleet from '../../components/Fleet'

const PremiumEliteEn = props => (
  <div className="page  Premium">
  <Helmet
          title={` Premium Vehicles for Rent | Budget Nicaragua`}
          meta={[
            {
              name: 'description',
              content:
                'Frequently Asked Questions about car rentals. ',
            },
          ]}
          link={[
            {
              rel: 'alternate',
              hreflang: 'en',
              href:
                './es/fleet/premium_elite',
            },
          ]}
        />
    <Breadcrumb
      lang={props.pathContext.langKey}
      currentPage={' Premium Cars'}
    />
    <h1> Premium Elite</h1>
    <Fleet
      lang={props.pathContext.langKey}
      types={props.data.dataJson.fleetTypes}
      fleet={props.data.dataJson.fleet}
      features={props.data.dataJson.fleetFeatures}
      category={8}
    />
  </div>
)

export const query = graphql`
  query PremiumEliteEN {
    dataJson(id: { regex: "/fleet/" }) {
      ...FleetData
    }
    allFile(filter: { relativeDirectory: { eq: "fleet" } }) {
      edges {
        node {
          name
          childImageSharp {
            resolutions {
              ...GatsbyImageSharpResolutions
            }
          }
        }
      }
    }
  }
`

export default PremiumEliteEn



// WEBPACK FOOTER //
// ./src/pages/fleet/premium_elite.en.js